__turbopack_context__.v({
  "icon": "q8D9yG_icon",
  "inner": "q8D9yG_inner",
  "is-active": "q8D9yG_is-active",
  "location": "q8D9yG_location",
  "photo": "q8D9yG_photo",
  "producer-card": "q8D9yG_producer-card",
  "producer-content": "q8D9yG_producer-content",
  "producer-marker": "q8D9yG_producer-marker",
  "producer-marker-card": "q8D9yG_producer-marker-card",
});
